import { useState, useEffect } from "react";
// Removed FontAwesome imports as they are not used in the provided Dashboard component
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faClock, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { domain } from "../auth/domain";
import Popup from "../components/Popup";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../components/CustomLoader";
import LinearProgress from "@mui/material/LinearProgress";
import * as React from "react";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import swal from "sweetalert";
import formatCurrency from "../shared/formatCurrency";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import HandshakeIcon from "@mui/icons-material/Handshake";
// import CollectionsIcon from "@mui/icons-material/Collections";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import PaymentIcon from "@mui/icons-material/Payment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ShieldIcon from "@mui/icons-material/Shield";
import { useBranch } from "../contexts/BranchContext";
import decodeJwtToken from "../auth/decodeJwtToken";
import formatRoleName from "../shared/formatRoleName";
import Alert from "@mui/material/Alert";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography"; // Already imported
import Card from "@mui/material/Card"; // New import for dashboard cards
import CardContent from "@mui/material/CardContent"; // New import for card content
import DescriptionIcon from '@mui/icons-material/Description'; // New import for 'Total Forms' icon
import Button from "@mui/material/Button";
import AlertTitle from "@mui/material/AlertTitle";
import NoRecords from "../shared/NoRecords";
import userImage from "../assets/img/user.jpg";
import { Chip, Grid, Paper } from "@mui/material";
import { formatDate } from "@canvasjs/charts";
import Tooltip from "@mui/material/Tooltip";
import PeopleIcon from '@mui/icons-material/People'; // New import for 'Customers' icon
import CollectionsIcon from '@mui/icons-material/Collections'; // New import for 'Collections' icon
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import "./Dashboard.css";

export const AnnouncementModal = ({ open, handleClose, announcement }) => {
  if (!announcement) return null;

  const { title, body, created_by, created_at, is_active_till, category } =
    announcement;

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          padding: 4,
          backgroundColor: "background.paper",
          borderRadius: 3,
          width: "50rem",
          maxHeight: "80vh", // Set a maximum height to prevent overflow
          margin: "auto",
          mt: 10,
          boxShadow: 24,
          position: "relative",
          overflowY: "auto", // Enable vertical scrolling when content overflows
          animation: "fadeIn 0.3s ease-in-out",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage:
              "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
            zIndex: -1,
          },
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            {title}
          </Typography>
          <Chip
            label={category}
            color={category === "URGENT" ? "error" : "warning"}
            sx={{ fontWeight: "bold", textTransform: "uppercase" }}
          />
        </Grid>
        <Typography sx={{ mb: 2, color: "text.secondary" }}>{body}</Typography>
        <Typography
          sx={{ mb: 2, color: "text.secondary", fontSize: "0.875rem" }}
        >
          <strong>Created by:</strong> {created_by}
        </Typography>
        <Typography
          sx={{ mb: 2, color: "text.secondary", fontSize: "0.875rem" }}
        >
          <strong>Created on:</strong> {formatDate(created_at)}
        </Typography>
        <Typography
          sx={{ mb: 2, color: "text.secondary", fontSize: "0.875rem" }}
        >
          <strong>Active until:</strong> {formatDate(is_active_till)}
        </Typography>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          sx={{
            width: "100%",
            borderRadius: 3,
            paddingY: 1.5,
            backgroundColor: "primary.main",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          }}
        >
          ACKNOWLEDGE
        </Button>
      </Box>
    </Modal>
  );
};

const Dashboard = () => {
  const accessToken = localStorage.getItem("accessToken");
  const me = decodeJwtToken(accessToken);
  const [showSpinner, setShowSpinner] = useState(false);
  const [bestSelling, setBestSelling] = useState(0);
  const [slowMoving, setSlowMoving] = useState(0);
  const [forms, setForms] = useState(0);
  const [expired, setExpired] = useState(0);
  const [outOfStock, setOutOfStock] = useState(0);
  const [lowStock, setLowStock] = useState(0);
  const [customers, setCustomers] = useState([]);
  const [todaySales, setTodaySales] = useState(0);
  const [loans, setLoans] = useState(0);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const { branch } = useBranch();
  const [customerReport, setCustomerReport] = useState({});
  const [loanReport, setLoanReport] = useState({});
  const [insuaranceReport, setInsuaranceReport] = useState({});
  const [collectionReport, setCollectionReport] = useState({});
  const [swiper, setSwiper] = useState(null);
  const [incomeReport, setIncomeReport] = useState({});
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (swiper) {
      swiper.slideTo(newValue);
    }
  };
  const handleLogout = () => {
    // Perform logout logic here
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    navigate("/"); // Navigate to the login page
  };
  const handleSlideChange = (swiperInstance) => {
    setValue(swiperInstance.activeIndex);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  const navigate = useNavigate();

  // fetch orders

  useEffect(() => {
    setShowSpinner(true);

    fetch(`${domain}loans/loans/loan_stats/?branch_id=${branch?.id}`, {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoanReport(data);
      })
      .catch((error) => console.error(error))
      .finally(() => setShowSpinner(false));

    fetch(`${domain}customers/customers/stats/?branch_id=${branch?.id}`, {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCustomerReport(data);
      })
      .catch((error) => console.error(error))
      .finally(() => setShowSpinner(false));

    fetch(`${domain}loans/loans/?branch_id=${branch?.id}`, {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Access only the first 10 items
        const firstTenLoans = data.slice(0, 10);
        setLoans(firstTenLoans);
      })
      .catch((error) => console.error(error))
      .finally(() => setShowSpinner(false));

    fetch(`${domain}forms/forms/?branch_id=${branch?.id}`, {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data["detail"]) {
          swal({ icon: "info", title: data["detail"] });
          handleLogout();
        }
        const totalForms = data.reduce((acc, current) => {
          return acc + current.total_forms;
        }, 0);

        setForms(totalForms);
      })
      .catch((error) => console.error(error))
      .finally(() => setShowSpinner(false));

    fetch(`${domain}customers/customers/?branch_id=${branch?.id}`, {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data["detail"]) {
          swal({ icon: "info", title: data["detail"] });
          handleLogout();
        }
        setCustomers(data);
      })
      .catch((error) => console.error(error))
      .finally(() => setShowSpinner(false));

    fetch(`${domain}reports/collections/?branch_id=${branch?.id}`, {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCollectionReport(data);
      });

    fetch(`${domain}reports/incomes/?branch_id=${branch?.id}`, {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIncomeReport(data);
      });
  }, [branch]);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <AnnouncementModal
        open={open}
        handleClose={handleClose}
        announcement={{
          id: 11,
          title: "Notify about announcement",
          body: "Notify about announcement Notify about announcement Notify about announcement Notify about announcement Notify about announcement Notify about announcement Notify about announcement",
          created_by: "ZAINABU BAKARI : Cashier",
          created_at: "2024-08-27T16:54:10.063588+03:00",
          updated_at: "2024-08-27T16:54:10.063588+03:00",
          is_active_till: "2024-08-29",
          category: "GENERAL",
          branches: [],
        }}
      />
      {showSpinner ? (
        <LinearProgress />
      ) : (
        <>
          <div className="row">
            <h3>Dashboard</h3>
          </div>
          <Grid container spacing={3} sx={{ mb: 3 }}>
            {/* Total Forms Card */}
            <Grid item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  boxShadow: 3, // Add some shadow for depth
                  "&:hover": {
                    boxShadow: 6, // Enhance shadow on hover
                    cursor: "pointer",
                  },
                }}
                // Uncomment and adjust path for navigation
                // onClick={() => navigate("/forms")}
              >
                <Box
                  sx={{
                    minWidth: 60,
                    minHeight: 60,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    backgroundColor: "info.main", // Use theme color for consistency
                    color: "info.contrastText",
                  }}
                >
                  <DescriptionIcon sx={{ fontSize: 30 }} />
                </Box>
                <Box sx={{ flexGrow: 1, textAlign: "right" }}>
                  <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
                    {forms}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    Total Forms
                  </Typography>
                </Box>
              </Card>
            </Grid>

            {/* Customers Card */}
            <Grid item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  boxShadow: 3,
                  "&:hover": {
                    boxShadow: 6,
                    cursor: "pointer",
                  },
                }}
                // Uncomment and adjust path for navigation
                // onClick={() => navigate("/customers")}
              >
                <Box
                  sx={{
                    minWidth: 60,
                    minHeight: 60,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    backgroundColor: "success.main", // Use theme color
                    color: "success.contrastText",
                  }}
                >
                  <PeopleIcon sx={{ fontSize: 30 }} />
                </Box>
                <Box sx={{ flexGrow: 1, textAlign: "right" }}>
                  <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
                    {customers?.length}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    Customers
                  </Typography>
                </Box>
              </Card>
            </Grid>

            {/* Loans Card */}
            <Grid item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  boxShadow: 3,
                  "&:hover": {
                    boxShadow: 6,
                    cursor: "pointer",
                  },
                }}
                // Uncomment and adjust path for navigation
                // onClick={() => navigate("/loans")}
              >
                <Box
                  sx={{
                    minWidth: 60,
                  minHeight: 60,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    backgroundColor: "primary.main", // Use theme color
                    color: "primary.contrastText",
                  }}
                >
                  <PaymentIcon sx={{ fontSize: 30 }} /> {/* Adjusted icon size */}
                </Box>
                <Box sx={{ flexGrow: 1, textAlign: "right" }}>
                  <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
                    {formatCurrency(loanReport?.total)}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    Loans
                  </Typography>
                </Box>
              </Card>
            </Grid>

            {/* Collections Card */}
            <Grid item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  boxShadow: 3,
                  "&:hover": {
                    boxShadow: 6,
                    cursor: "pointer",
                  },
                }}
                // Uncomment and adjust path for navigation
                // onClick={() => navigate("/collections")}
              >
                <Box
                  sx={{
                    minWidth: 60,
                    minHeight: 60,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    backgroundColor: "secondary.main", // Use theme color
                    color: "secondary.contrastText",
                  }}
                >
                  <CollectionsIcon sx={{ fontSize: 30 }} />
                </Box>
                <Box sx={{ flexGrow: 1, textAlign: "right" }}>
                  <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
                    {formatCurrency(collectionReport?.total)}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    Collections
                  </Typography>
                </Box>
              </Card>
            </Grid>

            {/* Income Card */}
            <Grid item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  boxShadow: 3,
                  "&:hover": {
                    boxShadow: 6,
                    cursor: "pointer",
                  },
                }}
                // Uncomment and adjust path for navigation
                // onClick={() => navigate("/income")}
              >
                <Box
                  sx={{
                    minWidth: 60,
                    minHeight: 60,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    backgroundColor: "warning.main", // Use theme color
                    color: "warning.contrastText",
                  }}
                >
                  <PriceCheckIcon sx={{ fontSize: 30 }} /> {/* Adjusted icon size */}
                </Box>
                <Box sx={{ flexGrow: 1, textAlign: "right" }}>
                  <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
                    {formatCurrency(incomeReport?.total)}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    Income
                  </Typography>
                </Box>
              </Card>
            </Grid>

            {/* Insurance Card */}
            <Grid item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  boxShadow: 3,
                  "&:hover": {
                    boxShadow: 6,
                    cursor: "pointer",
                  },
                }}
                // Uncomment and adjust path for navigation
                // onClick={() => navigate("/insurance")}
              >
                <Box
                  sx={{
                    minWidth: 60,
                    minHeight: 60,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    backgroundColor: "error.main", // Use theme color
                    color: "error.contrastText",
                  }}
                >
                  <ShieldIcon sx={{ fontSize: 30 }} /> {/* Adjusted icon size */}
                </Box>
                <Box sx={{ flexGrow: 1, textAlign: "right" }}>
                  <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
                    {formatCurrency(loanReport?.total * 0.1)}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    Insurance
                  </Typography>
                </Box>
              </Card>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="inherit"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                  >
                    <Tab label="Customers" {...a11yProps(0)} />
                    <Tab label="Loans" {...a11yProps(1)} />
                    <Tab label="Collections" {...a11yProps(2)} />
                    <Tab label="Income" {...a11yProps(3)} />
                    <Tab label="Insurance" {...a11yProps(4)} />
                  </Tabs>

                  <Box sx={{ p: 2 }}>
                    <Swiper
                      onSwiper={setSwiper}
                      onSlideChange={handleSlideChange}
                      initialSlide={value}
                    >
                      <SwiperSlide>
                        <TabPanel value={value} index={0} dir={theme.direction}>
                          <TableContainer component={Paper} elevation={0} variant="outlined">
                            <Table aria-label="customer report table">
                              <TableHead sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
                                <TableRow>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Today</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Week</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Month</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Year</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell>{customerReport?.total_today || 0}</TableCell>
                                  <TableCell>{customerReport?.total_this_week || 0}</TableCell>
                                  <TableCell>{customerReport?.total_this_month || 0}</TableCell>
                                  <TableCell>{customerReport?.total_this_year || 0}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </TabPanel>
                      </SwiperSlide>
                      <SwiperSlide>
                        <TabPanel value={value} index={1} dir={theme.direction}>
                          <TableContainer component={Paper} elevation={0} variant="outlined">
                            <Table aria-label="loan report table">
                              <TableHead sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
                                <TableRow>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Today</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Week</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Month</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Year</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell>{formatCurrency(loanReport?.total_today)}</TableCell>
                                  <TableCell>{formatCurrency(loanReport?.total_this_week)}</TableCell>
                                  <TableCell>{formatCurrency(loanReport?.total_this_month)}</TableCell>
                                  <TableCell>{formatCurrency(loanReport?.total_this_year)}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </TabPanel>
                      </SwiperSlide>
                      <SwiperSlide>
                        <TabPanel value={value} index={2} dir={theme.direction}>
                          <TableContainer component={Paper} elevation={0} variant="outlined">
                            <Table aria-label="collection report table">
                              <TableHead sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
                                <TableRow>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Today</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Week</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Month</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Year</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell>{formatCurrency(collectionReport?.total_today)}</TableCell>
                                  <TableCell>{formatCurrency(collectionReport?.total_this_week)}</TableCell>
                                  <TableCell>{formatCurrency(collectionReport?.total_this_month)}</TableCell>
                                  <TableCell>{formatCurrency(collectionReport?.total_this_year)}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </TabPanel>
                      </SwiperSlide>
                      <SwiperSlide>
                        <TabPanel value={value} index={3} dir={theme.direction}>
                          <TableContainer component={Paper} elevation={0} variant="outlined">
                            <Table aria-label="income report table">
                              <TableHead sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
                                <TableRow>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Today</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Week</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Month</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Year</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell>{formatCurrency(incomeReport?.total_today)}</TableCell>
                                  <TableCell>{formatCurrency(incomeReport?.total_this_week)}</TableCell>
                                  <TableCell>{formatCurrency(incomeReport?.total_this_month)}</TableCell>
                                  <TableCell>{formatCurrency(incomeReport?.total_this_year)}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </TabPanel>
                      </SwiperSlide>
                      <SwiperSlide>
                        <TabPanel value={value} index={4} dir={theme.direction}>
                          <TableContainer component={Paper} elevation={0} variant="outlined">
                            <Table aria-label="insurance report table">
                              <TableHead sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
                                <TableRow>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Today</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Week</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Month</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>This Year</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell>{formatCurrency(loanReport?.total_today * 0.1)}</TableCell>
                                  <TableCell>{formatCurrency(loanReport?.total_this_week * 0.1)}</TableCell>
                                  <TableCell>{formatCurrency(loanReport?.total_this_month * 0.1)}</TableCell>
                                  <TableCell>{formatCurrency(loanReport?.total_this_year * 0.1)}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </TabPanel>
                      </SwiperSlide>
                    </Swiper>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ mt: 0 }}>
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6">10 Latest Loan Applications</Typography>
                    <Button
                    variant="contained"
                    onClick={() => navigate("/loans")}
                  >
                    View
                  </Button>
                  </Box>
                  <TableContainer>
                    <Table stickyHeader aria-label="latest loans table">
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Customer</TableCell>
                          <TableCell>Branch</TableCell>
                          <TableCell>Category</TableCell>
                          <TableCell>Amount</TableCell>
                          <TableCell>Repayment</TableCell>
                          <TableCell>Start Date</TableCell>
                          <TableCell>End Date</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {(() => {
                        try {
                          return loans.map((loan, index) => {
                            const groupName = me?.group?.name;
                            const loanStatus = loan?.status;

                            return (
                              <TableRow hover key={loan?.id}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{loan?.customer?.full_name}</TableCell>
                                <TableCell>{loan?.branch?.name}</TableCell>
                                <TableCell>{loan?.loan_category}</TableCell>
                                <TableCell>{formatCurrency(loan?.amount)}</TableCell>
                                <TableCell>{loan?.repayment_method}</TableCell>
                                <TableCell>{loan?.start_date}</TableCell>
                                <TableCell>{loan?.end_date}</TableCell>
                                <TableCell>
                                  {loanStatus.includes("REJECTED") ? (
                                    <Tooltip title={loan?.rejection_reason || ''} arrow>
                                      <Chip label={formatRoleName(loanStatus)} color="error" size="small" />
                                    </Tooltip>
                                  ) : formatRoleName(loanStatus).includes(`Wait For ${groupName}`) ? (
                                    <Chip label="Waiting for you" color="info" size="small" />
                                  ) : loanStatus === "APPROVED_BY_GENERAL_MANAGER" ? (
                                    <Chip label={formatRoleName(loanStatus)} color="success" size="small" />
                                  ) : loanStatus.startsWith("APPROVED") ? (
                                    <Chip label={formatRoleName(loanStatus)} color="warning" size="small" />
                                  ) : (
                                    <Chip label={formatRoleName(loanStatus)} color="secondary" size="small" />
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          });
                        } catch (error) {
                          console.log(error);
                          return (
                            <tr>
                              <td colSpan={10}>
                                <Alert severity="error">Network Problem. Please check your Internet.</Alert>
                              </td>
                            </tr>
                          );
                        }
                      })()}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {loans && loans.length === 0 && (
                    <Box sx={{ mt: 2 }}>
                      <NoRecords data={loans} />
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default Dashboard;
